export default __webpack_public_path__ + "static/media/wave-mobile.c3c4cd72.svg";